export default {
      id: "i-menu-control-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/sprite.svg#i-menu-control",
      toString: function () {
        return this.url;
      }
    }